export default __webpack_public_path__ + "static/media/telephone.02e848de.svg";